import Vue from "vue";
Vue.component("search-bar-vue", {
  data: function() {
    return {
      isOpen: false,
      focusableElements: [],
    }
  },

  watch: {
    isOpen: function(value) {
      if (value) {
        // Set focusable elements when modal is open.
        setTimeout(() => {
          this.setFocusableElements();
        }, 400);
      }
      else {
        // Reset focusable elements.
        setTimeout(() => {
          this.focusableElements = []
        }, 400);
      }
    }
  },

  methods: {
    /**
     * Set focusable elements inside the filter modal when opened.
     * Focusable elements include links, buttons, form inputs, and the search input.
     */
    setFocusableElements() {
      this.focusableElements = [];

      const filterModal = document.querySelector(".filter-modal");
      if (filterModal) {
        this.focusableElements = Array.from(filterModal.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'))
            .filter(el => this.isElementVisible(el));
      }
    },

    /**
     * Check if an element is visible (i.e., not hidden by CSS).
     *
     * @param {HTMLElement} element - The element to check for visibility.
     * @returns {boolean} - Returns true if the element is visible, false if hidden.
     */
    isElementVisible(element) {

      const style = window.getComputedStyle(element);
      return (
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          style.opacity !== '0'
      );
    },

    /**
     * Handles keyboard navigation for trapping focus inside the filter modal.
     * Loops focus from the last element back to the first and vice versa.
     */
    handleKeydown(event) {
      const {key} = event;
      const modal = document.querySelector(".filter-modal");

      if (this.isOpen) {
        if (key === 'Escape') {
          // Close the filter modal when Escape is pressed.
          modal.style.display = "none";
          this.isOpen = false;
          return;
        }

        // Trap focus inside the filter modal.
        if (key === 'Tab') {
          const focusableLength = this.focusableElements.length;
          const focusedIndex = this.focusableElements.indexOf(document.activeElement);

          if (event.shiftKey && focusedIndex === 0) {
            // If Shift + Tab is pressed on the first focusable element, focus the last one
            event.preventDefault();
            this.focusableElements[focusableLength - 1].focus();
          } else if (!event.shiftKey && focusedIndex === focusableLength - 1) {
            // If Tab is pressed on the last focusable element, focus the first one
            event.preventDefault();
            this.focusableElements[0].focus();
          }
        }
      }
    },

    /**
     * Handle keydown on custom-checkbox to toggle checkbox with Enter/Space
     */
    handleCustomCheckboxKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {

        const checkboxInput = event.currentTarget.querySelector('input[type="checkbox"]');
        if (checkboxInput) {
          event.preventDefault();
          checkboxInput.checked = !checkboxInput.checked;
          checkboxInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    },

    /**
     * Add keydown listeners to custom-checkboxes
     */
    addCustomCheckboxKeyListeners() {
      const filterModal = document.querySelector('.filter-modal');
      if (filterModal) {
        const customCheckboxes = filterModal.querySelectorAll('.custom-checkbox');
        customCheckboxes.forEach(cb => {
          cb.addEventListener('keydown', this.handleCustomCheckboxKeydown);
        });
      }
    },

    /**
     * Opens the filter modal and sets up focus management
     */
    openFilterModal(modal, closeBtn) {
      modal.style.display = "block";
      this.isOpen = true;

      setTimeout(() => {
        closeBtn.focus();
        this.addCustomCheckboxKeyListeners();
        this.setFocusableElements();
      }, 50);
    },

    /**
     * Closes the filter modal and cleans up focus management
     */
    closeFilterModal(modal) {
      modal.style.display = "none";
      this.isOpen = false;
    },
  },

  mounted() {
    // Set up event listener for keydown
    window.addEventListener('keydown', this.handleKeydown);

    const crossBtn = document.querySelector(".searchPill__cross-button");
    const inputField = document.querySelector(".searchPill-input");
    const searchBtn = document.querySelectorAll('.search-bar__search .btn');

    inputField.addEventListener('input', function() {
      if (inputField.value !== '') {
        crossBtn.classList.remove('searchPill__cross-button-disable')
      }
      else {
        crossBtn.classList.add('searchPill__cross-button-disable')
      }
    })

    function clearErrors() {
      searchBtn.forEach(item => {
        item.classList.remove("search-btn-disable");
      })
    }

    crossBtn.addEventListener("click", function(event) {
      event.preventDefault();
      inputField.value = "";
      crossBtn.classList.add('searchPill__cross-button-disable');
      clearErrors();
    });

    //advanced filter modal
    var modal = document.querySelector(".filter-modal");
    var filterBtn = document.querySelectorAll(".search-bar__filter");
    var closeBtn = document.querySelector('.filter-modal .advanced-filters-close-btn');
    var cancelBtn = document.querySelector('.filter-modal .btn_cancel');

    filterBtn.forEach(item => {
      item.onclick = (event) => {
        event.preventDefault();
        this.openFilterModal(modal, closeBtn);
      }
    });

    closeBtn.onclick = () => {
      this.closeFilterModal(modal);
    }

    cancelBtn.onclick = () => {
      this.closeFilterModal(modal);
    }

    window.onclick = (event) => {
      if (event.target == modal) {
        this.closeFilterModal(modal);
      }
    }

    //tag
    const closeTagButton = this.$el.querySelectorAll(".tag__icon");
    if (closeTagButton.length) {
      closeTagButton.forEach(element => {
        element.addEventListener("click", function(e) {
          const ele = e.target;
          const eletag = ele.closest('.tag');
          eletag.remove();
        });
      });
    }

    function updateListWidth() {
      const searchBarInput = document.querySelector('.search-bar__input');
      const dynamicList = document.querySelector('.auto-complete-wrapper');
      const itemWidth = searchBarInput.clientWidth;
      dynamicList.style.width = itemWidth + 'px';
    }
    window.addEventListener('resize', updateListWidth);

  }
});
